module.exports = __webpack_public_path__ + "media/32 lie ahead.e6031ec9.mp3";